import styled from 'styled-components'
export const Wrapper = styled.div`
  .description {
    max-width: 410px;
    white-space: normal;
  }
  .dynamicButtons {
    margin-left: auto;
    width: fit-content;
    margin-bottom: 1.25rem;
  }
  .subscribers-active {
    color: var(--second-color);
  }
  .subscribers-passive {
    color: #929292;
  }
`
